import { useState, useEffect } from 'react'
import { useIntl, defineMessages } from 'react-intl'
import { useQuery, gql } from '@apollo/client'
import { isEmpty } from 'lodash'

import { Autocomplete } from 'components/v2/Autocomplete'
import { filterEmptyValue } from 'utils/object'

const GET_CAMPAIGN_AUTOCOMPLETE = gql`
  query GetCampaignAutocomplete($limit: Int, $companyId: ID, $areas: [CampaignArea!]) {
    campaigns(input: { limit: $limit, companyID: $companyId, areas: $areas }) {
      id
      name
      startsAt
      endsAt
      timezone
      company {
        id
        name
      }
    }
  }
`

const messages = defineMessages({
  error: {
    id: 'campaigns.autocomplete.error',
    defaultMessage: 'There was an issue while loading your campaigns'
  },
  empty: {
    id: 'campaigns.autocomplete.empty',
    defaultMessage: 'No campaigns found'
  }
})

export const CampaignAutocomplete = (props: TSFixMe): TSFixMe => {
  const intl = useIntl()
  const [pattern, setPattern] = useState('')

  const { data, loading, error, refetch } = useQuery(GET_CAMPAIGN_AUTOCOMPLETE, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: filterEmptyValue({
      limit: 1000,
      companyId: props.companyId,
      areas: props.areas
    })
  })

  useEffect((): TSFixMe => {
    refetch()
  }, [])

  const shownItems =
    (data &&
      data.campaigns &&
      data.campaigns.filter((campaign: TSFixMe): TSFixMe => {
        const hasPattern = campaign.name.toLowerCase().indexOf(pattern.toLowerCase()) > -1

        if (props.filter) {
          return hasPattern && props.filter(campaign)
        }
        return hasPattern
      })) ||
    []

  const handleChange = (campaign: TSFixMe, { inputValue = '' } = {}): TSFixMe => {
    setPattern(inputValue)

    if (!isEmpty(campaign)) {
      props.onChange(campaign)
    } else {
      props.onChange({
        id: '',
        name: ''
      })
    }
  }
  return (
    <Autocomplete
      {...props}
      items={shownItems}
      getItemLabel={(campaign: TSFixMe): void => campaign.name}
      loading={loading}
      error={error}
      errorMessage={intl.formatMessage(messages.error)}
      emptyMessage={intl.formatMessage(messages.empty)}
      onChange={handleChange}
    />
  )
}
